import axios from "axios";

export default axios.create({
    baseURL: 'https://modena.monte360.com/investor/deleteInvestment.php',
    headers: {
        "Content-Type": "application/json",
} 
});